import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Grid, Message } from "semantic-ui-react";
import PhotoEditingJob from "~/models/PhotoEditing/PhotoEditingJob";

@observer
class PricingInfoMessage extends Component {
  render() {
    const { photoEditingJob } = this.props;

    if (!photoEditingJob.isEntitledToFreeProduct) {
      return null;
    }

    return (
      <Grid.Row>
        <Grid.Column width={16}>
          <Message positive>
            <Message.Header>Get up to 50 HDR images for FREE!</Message.Header>
            <p>Your first job (up to 50 images) is FREE for this tour.</p>
          </Message>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

PricingInfoMessage.propTypes = {
  photoEditingJob: PropTypes.instanceOf(PhotoEditingJob),
};

export default PricingInfoMessage;
